// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__3yamk","text":"Loader_text__uupzy","content":"Loader_content__rvat_","span":"Loader_span__qI8wq","loaderSpan":"Loader_loaderSpan__hIbqq"};